import { Component, Inject, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorReferenceService } from '../observability/error-reference.service';

export interface DialogAlertData {
  reason: string;
  /** Optional heading above the message. */
  title?: string;
  /** Material icon name shown in the badge. Defaults to "info". */
  icon?: string;
  /** "error" tints the icon badge; "neutral" (default) keeps it muted. */
  tone?: 'neutral' | 'error';
  /** Label for the single dismiss button. Defaults to "Close". */
  action?: string;
  /** Error reference shown with a copy button (set by NotificationService.ErrorAlertDialog). */
  reference?: string;
}

@Component({
  standalone: false,
  selector: 'odin-dialog-alert',
  templateUrl: './dialog-alert.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dialog-alert.component.css'],
})
export class DialogAlertComponent {
  private readonly errorReference = inject(ErrorReferenceService);

  constructor(
    public dialogRef: MatDialogRef<DialogAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogAlertData,
  ) {}

  public copyReference(): void {
    if (this.data.reference) {
      this.errorReference.copy(this.data.reference);
    }
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
